// extracted by mini-css-extract-plugin
export default {"spinner":"Spinner_spinner__0jGOk","spin":"Spinner_spin__oBgC4"};